export default "__VITE_ASSET__lw4Hv739__"